"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.isMobileDevice = exports.isLocalDevelopment = void 0;
const apiHost_1 = require("./apiHost");
/**
 * Check if running in local development
 */
const isLocalDevelopment = () => {
    return (0, apiHost_1.isLocalHostname)(window.location.hostname);
};
exports.isLocalDevelopment = isLocalDevelopment;
/**
 * Detect if the user is on a mobile device
 */
const isMobileDevice = () => {
    const userAgent = navigator.userAgent || navigator.vendor || window.opera;
    const mobileRegex = /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i;
    const isMobileUA = mobileRegex.test(userAgent);
    const hasTouchScreen = 'ontouchstart' in window || navigator.maxTouchPoints > 0;
    const isSmallScreen = window.innerWidth <= 768;
    return isMobileUA || (hasTouchScreen && isSmallScreen);
};
exports.isMobileDevice = isMobileDevice;
